export default "__VITE_ASSET__DU$OVmqo__"